export const INVOICE_TYPE_INVOICE = {
	label: 'Facture',
	reference: 'invoice',
};

export const INVOICE_TYPE_REFUND = {
	label: 'Avoir',
	reference: 'refund',
};
